import axios from "../auth/FetchInterceptor";

const fetchReports = async ({ page = 1, limit = 10, status, search }) => {
    const response = await axios.get("/reports", {
        params: { page, limit, status, search },
    });
    return response.data.data;
};

const updateReportStatus = async ({ id, status }) => {
    const response = await axios.patch(`/reports/${id}/status`, { status });
    return response.data.data;
};

const reportService = {
    fetchReports,
    updateReportStatus,
};

export default reportService;

